// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"6a958358","703":"93573966"}[chunkId] + ".chunk.js";
};